export default {
  meau: {
    nav1: 'Homepage',
    nav2: 'Community',
    nav3: 'Download',
    nav4: 'Node Reward',
    nav5: 'NFT'
  },
  cont1: {
    text1: 'Blockchain based remote control software',
    text2: 'Multi-screen connectivity for work and play anytime, anywhere',
    btn: 'Download Now',
    text3_1: 'Join',
    text3_2: 'the community',
    text3_3: 'to get DeepLink Coin rewards!'
  },
  cont2: {
    text1: 'DeepLink',
    text2: 'Rely on gaming-grade, low-latency technology capabilities to bring all devices within reach',
    text3: 'Core competencies and technical strengths',
    text4: 'Based on the core capabilities of cloud gaming, the experience is far superior to traditional remote control!',
    leaf1: {
      text1: 'Highly smooth, high performance',
      text2: 'Low cost',
      text3: 'Industry-leading codec solution with minimal performance consumption and resource usage at the same code rate',
      text4: 'peer-to-peer:Supports ipv6 with up to 95% NAT throughput and zero bandwidth usage.'
    },
    leaf2: {
      text1: 'High frame rate, low latency',
      text2: '',
      text3: "With LAN latency <15ms and 4K 240Hz capability, the WAN review is also in the world's top tier."
    },
    leaf3: {
      text1: 'High definition',
      text2: '',
      text3: 'Intelligent algorithms enhance viewing at the same bit rate and restore the most realistic colour performance.'
    },
    leaf4: {
      text1: 'Highly stable',
      text2: '',
      text3: 'Anti-packaging loss and anti-congestion strategies supported by large amounts of data, allowing for rapid adjustment to data packaging loss and congestion.'
    },
    leaf5: {
      text1: 'Highly secure',
      text2: '',
      text3: 'All data is encrypted by DTLS1.2 with AES256.'
    }
  },
  cont3: {
    text1: "So smooth it's like controlling a local device",
    text2: 'Applying dozens of optimisation techniques in three main areas, DeepLink is able to maintain a high frame rate despite a 5% packaging loss rate and 100ms network latency*. Meeting the requirements of all types of network environments.',
    li1: {
      text1: 'Weak network countermeasure technology',
      text2: 'FEC anti-packaging loss strategy',
      text3: 'Bandwidth Forecast',
      text4: 'SVC coding strategy'
    },
    li2: {
      text1: 'Transmission optimisation techniques',
      text2: 'Port fingerprint prediction',
      text3: 'Supports IPV6',
      text4: 'UPNP',
      text5: 'Intelligent routing'
    },
    li3: {
      text1: 'Display processing technology',
      text2: 'Frame rate adaptation strategy',
      text3: 'Motion picture prediction',
      text4: 'Jitter processing strategy',
      text5: 'AI low-coding HD rendering',
      text6: 'Dynamic virtual reality ware'
    },
    desc3: 'LAN < 5 ms - Intercity network < 10 ms - Interprovincial network < 30 ms'
  },
  cont4: {
    text1: 'Super clear graphic quality',
    text2: 'Ultra HD resolution',
    text3: '1.07 billion colours supported',
    text4: '4:4:4 undamaged picture quality',
    text5: "DeepLink always uses more demanding image quality metrics to achieve an image experience that far exceeds other traditional remote technologies, with remote image distortion below the limit of human recognition, fully supporting the creative industry's demand for precise picture display.",
    text6: '*PSNR refers to Peak Signal to Noise Ratio, below 20dB the picture distortion is high, 20-30dB the picture distortion is average, 30-40dB the picture distortion is low, above 40dB the picture distortion is extremely low and undetectable to the naked eye.'
  },
  cont5: {
    text1: 'Extensive peripheral support',
    text2: 'DeepLink provides remote support for professional accessories such as digital boards and joysticks for the creative industry, and optimises the use of creative software such as PS, Zbrush and Unity to ensure a consistent experience of creative production tools in both remote and local states.'
  },
  cont6: {
    text1: 'Multiple guarantees - minimalist approach',
    block1: {
      title1: 'Secure accounts',
      desc1: 'Multi-layer account protection mechanism for peace of mind',
      title2: 'Secure connection',
      desc2: 'DTLS1.2 protocol protection, access only with authorisation',
      title3: 'Secure data',
      desc3: '256-bit AES encryption, secure throughout transmission',
      title4: 'Secure devices',
      desc4: 'Only the corresponding person will see the corresponding device according to your settings'
    },
    block2: {
      title1: 'Multiple security guarantees',
      desc1: 'Safeguarding every connection',
      title2: 'Easy to use',
      desc2: 'Easy to start'
    },
    block3: {
      title1: 'Lightweight for downloading',
      desc1: "For DeepLink's client-end it's only about 10M",
      title2: 'Easy to learn',
      desc2: 'The configuration process can be completed by following the guidelines',
      title3: 'Easy to use',
      desc3: 'Remote control of any device within your rights via the mouse'
    }
  },
  cont7: {
    text1: 'Dedicated to offer remote control solutions',
    block1: {
      word1: 'Education industry',
      word2: 'Game industry',
      word3: 'Creative & design industry',
      word4: 'IT industry',
      word5: 'Businessmen and women on the go',
      word6: 'Co-contributors around the world',
      word7: 'IT O&M Remote Maintenance',
      word8: 'Individual users and gamers'
    },
    block2: {
      text1: 'Support for remote control scenarios in various industries',
      text2: 'Based on the actual needs of companies in various industries, we help them to achieve their business goals in an energy-efficient manner.',
      text3: 'Offers personalisation and encryption policies, flexible security',
      text4: "The company's employees are able to access the company's resources at any time and from anywhere based on their actual permissions."
    },
    block3: {
      text1: 'Covering a wide range of user needs',
      text2: 'Whether you choose to use it for your in-house staff,',
      text3: 'or for external customers, collaborators, or even personal use.',
      text4: 'Our remote control capabilities can serve you on major platforms and devices,',
      text5: 'offering an alternative, simple and clever way of solving problems.'
    }
  },
  footer: {
    link: 'Links',
    community: 'Follow our community',
    tip: 'Our communities on: Twitter、telegram、reddit、medium、discord、tiktok、YouTube'
  },
  reward: {
    title1: 'DeepLink node(s)',
    desc1: 'Have access to rewards, e.g. DeepLink Token, Crown NFT, power of community governance.',
    title2: 'Get Genesis Node NFT',
    text1: "The more users in DeepLink's network, the more computation and traffic are needed. Genesis Nodes provide infrastructure for DeepLink network, thus decentralizing and helping DeepLink grow faster.",
    text2: 'By purchasing a Genesis Node NFT, you get the opportunity to be rewarded for your contribution to the network.',
    text3: 'This may include DeepLink Token, Crown NFT, and the power of community governance.',
    text4_1: 'Have questions? Come talk to us on',
    text4_2: 'and',
    text4_3: '',
    btntext: 'Buy now',
    text5: 'For every 1,000 Genesis Nodes NFT sold, the price increases by 1,000USD',
    text6_1: 'The number of nodes',
    text6_2: 'each NFT supports currently',
    text7: 'Total number of Genesis nodes NFT',
    text8: 'Issuance capped forever',
    text9: 'Initial price',
    text10_1: 'Maximum number of nodes',
    text10_2: 'Supported per NFT',
    text11: 'Maximum price',
    text12: 'What is a Genesis node?',
    text13: 'Genesis nodes undertake the core tasks of DeepLink network computing and traffic forwarding, and DeepLink enables more people to participate in gaining revenue through the mining model.',
    text14: 'How many Tokens in total have been given to Genesis nodes for rewards?',
    text15: '30% of the total number of tokens, i.e.30 billion DeepLink Token',
    text16: 'What is the Genesis Node NFT',
    text17: 'Only those who have Genesis Node NFT can participate in mining.',
    text18: 'How is the revenue from the sale of Genesis Node NFT distributed?',
    text19: '50% of the proceeds are invested in decentralized liquidity reward pools (e.g. DeepLink Token/USDC for Uniswap, Sushiswap) and 50% goes to DeepLink operating company as proceeds.',
    text20: 'What is the specific mining mechanism?',
    text21: 'The total reward is 5 billion a year, halved every 3 years, 10% of DeepLink Crown NFT revenue is used to buy back DeepLink Token to be added to the total reward pool before each halving, as part of the 50% reward Token, awarded to all nodes in 3 years. For example, after 3 years, 10% of DeepLink Crown NFT earnings can repurchase 12 billion DeepLink Token, then the total remaining reward pool becomes: 12 billion + 15 billion, a total of 27 billion, and the total annual reward from the second 3-years is 27 billion * 50% * 1/3 = 4.5 billion.',
    text22: 'What are the requirements for Genesis node machines?',
    text23: "Each machine must already be in DeepBrain Chain's network. DeepBrain Chain is a decentralized high-performance computing network, and the machines in DeepBrain Chain have pledged DBC, which can guarantee the stability of the machines. For more information about DeepBrain Chain:",
    text24: 'What are the other benefits of holding a Genesis Node NFT?',
    details: {
      text1: "1. Holding a certain number of Genesis Node NFTs gives you the general agency right to sell DeepLink NFTs in a country (1 NFT is needed for every 3 million people according to the country's population ratio);",
      text2: '2.DeepLink Coin airdrop;',
      text3: '3.DeepLink incubated gaming project token airdrop;',
      text4: '4. Right to vote for which games to be launched online;',
      text5: '5. Game NFT purchase discount;',
      text6: '6. Cloud game rights and hours purchase discount;',
      text7: '7. Other rights to participate in community governance.'
    }
  },
  nft: {
    cont: {
      title1: 'Crown NFT',
      desc1: 'With this NFT, you can have 1 year access to all enterprise features of DeepLink software.',
      desc2: 'NFT is dormant after being purchased, when this NFT needs to be used, it can be activated in DeepLink software, when NFT is activated',
      desc3: '1 year usage period countdown begins. 10% of DeepLink software NFT revenue is invested in node rewards,',
      desc4: '40% of the proceeds are invested in the liquidity reward pool, and 50% is DeepLink operating company proceeds.'
    },
    enabl: {
      title1: 'NFT Rights',
      desc1: '1 year access to all enterprise features of DeepLink software',
      desc2: 'DeepLink Coin airdrop',
      desc3: 'DeepLink incubated gaming project token airdrop',
      desc4: 'Right to vote for which games to be launched online',
      desc5: 'Game NFT purchase discount',
      desc6: 'Cloud game rights and hours purchase discount',
      desc7: 'Other rights to participate in community governance'

    },
    edition: {
      title1: 'Professional version',
      title2: 'Enterprise version',
      tip: 'Crown NFT',
      btn: 'Buy now',
      title3: 'Professional VS Enterprise',
      desc: 'Specific features access',
      list: {
        li1_1: 'Content',
        li1_2: 'Basic version',
        li1_3: 'Professional version',
        li1_4: 'Enterprise version',
        li2_1: 'Best picture quality',
        li3_1: 'Forwarding server room',
        li3_2: 'Small amount',
        li3_3: 'Large amount',
        li4_1: 'Forwarding bandwidth',
        li4_2: 'Maximum 4M',
        li4_3: 'Maximum20M',
        li4_4: 'Unlimited',
        li5_1: 'End-to-end delay',
        li5_2: 'Minimum <40ms',
        li5_3: 'Minimum <20ms',
        li6_1:'Number of channels',
        li7_1:'Number of devices',
        li8_1:'Remote Desktop',
        li9_1:'Remote camera',
        li10_1:'Remote SSH',
        li11_1:'Privacy Screen',
        li12_1:'Virtual monitor',
        li13_1:'Gaming keypad',
        li14_1:'Multi-streaming',
        li15_1:'444 True color',
        li16_1:'Record screenshots',
        li17_1:'Dual Screen to Dual Screen',
        li18_1:'Handle, digital pad',
        li19_1:'User/Device Grouping Management',
        li20_1:'SSO Single Sign-In',
        li21_1:'Unified Management Authorization',
        li22_1:'Bulk Deployment',
        li23_1:'Employee Behavior Audit',
        li24_1:'Watermark',
        li25_1:'Price'
      }
    }
  }
}